"use strict";
/* tslint:disable */
var load_themed_styles_1 = require("@microsoft/load-themed-styles");
var styles = {
    root: 'root_449dd16d',
    rootIsNone: 'rootIsNone_449dd16d',
    rootIsDark: 'rootIsDark_449dd16d',
};
load_themed_styles_1.loadStyles([{ "rawString": ".root_449dd16d{background-color:" }, { "theme": "whiteTranslucent40", "defaultValue": "rgba(255,255,255,.4)" }, { "rawString": ";position:absolute;bottom:0;left:0;right:0;top:0}.root_449dd16d.rootIsNone_449dd16d{visibility:hidden}.root_449dd16d.rootIsDark_449dd16d{background-color:" }, { "theme": "blackTranslucent40", "defaultValue": "rgba(0,0,0,.4)" }, { "rawString": "}" }]);
module.exports = styles;
/* tslint:enable */ 

//# sourceMappingURL=Overlay.scss.js.map



//////////////////
// WEBPACK FOOTER
// ./~/office-ui-fabric-react/lib/components/Overlay/Overlay.scss.js
// module id = 260
// module chunks = 0